import { getEnv } from "@ace/env";
import { sessionStorageKeys } from "../constants";
import { ProfileData } from "@archax/web-lib";

export const getProfile = async (): Promise<ProfileData> => {
  const response = await fetch(
    `${getEnv("VITE_ACE_WEB_AUTH_SERVER")}/profile`,
    {
      headers: {
        Authorization: `Bearer ${globalThis.sessionStorage.getItem(
          sessionStorageKeys.token,
        )}`,
      },
    },
  );

  const res = await response.json();

  if (res.status === "ERROR") {
    const error = res.error[0].msg;
    throw new Error(error);
  }

  return res.data;
};
